import React from "react";
import "./Blog.css";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { FaUser, FaCalendarAlt } from "react-icons/fa";

export default function Blog() {
  const blogPosts = [
    {
      id: 1,
      title: "The Future of Online Medical Learning",
      author: "Dr. Priya Sharma",
      date: "Oct 15, 2025",
      img: "https://i.pinimg.com/736x/b6/96/ee/b696ee610d8aac5441d3d68cf64f6242.jpg",
      excerpt:
        "Discover how AI-driven learning platforms are transforming how medical professionals upskill with interactive and flexible programs.",
    },
    {
      id: 2,
      title: "How to Balance Clinical Practice & Online Courses",
      author: "Dr. Rahul Verma",
      date: "Oct 10, 2025",
      img: "https://i.pinimg.com/736x/0d/b5/61/0db561697eabc8be9a7c6ad46c7ae3c5.jpg",
      excerpt:
        "Learn effective time management strategies that allow doctors to pursue continuous education while maintaining patient care quality.",
    },
    {
      id: 3,
      title: "Top 5 Fellowship Courses to Advance Your Career",
      author: "Dr. Meera Gupta",
      date: "Sep 28, 2025",
      img: "https://i.pinimg.com/736x/a6/4a/c1/a64ac15baada8145a58d1acee5d34d81.jpg",
      excerpt:
        "We’ve listed the most in-demand fellowship programs that enhance both knowledge and global career opportunities for healthcare professionals.",
    },
  ];

  return (
    <div className="blog-page">
      <Navbar />

      {/* Hero Section */}
      <section className="blog-hero">
        <div className="blog-hero-content">
          <h1>
            Welcome to the <span>Medby Blog</span>
          </h1>
          <p>
            Stay informed with the latest trends, insights, and updates in the
            world of medical education and healthcare innovation.
          </p>
        </div>

        <ul className="blog-circles">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
      </section>

      {/* Blog Cards Section */}
      <section className="blog-section">
        <div className="blog-container">
          {blogPosts.map((post) => (
            <div className="blog-card" key={post.id}>
              <div className="blog-img">
                <img src={post.img} alt={post.title} />
              </div>
              <div className="blog-content">
                <h3>{post.title}</h3>
                <div className="blog-meta">
                  <span>
                    <FaUser /> {post.author}
                  </span>
                  <span>
                    <FaCalendarAlt /> {post.date}
                  </span>
                </div>
                <p>{post.excerpt}</p>
                <button className="blog-btn">Read More →</button>
              </div>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}
